/**
 * Adds the Meta dedupe id onto the existing GA4 dataLayer payloads.
 *
 * GA4 field names are left as they are. `meta_event_id` is an extra key for
 * the GTM Meta tags (StartTrial on `sign_up`, Purchase on `purchase`).
 */

import { DEFAULT_META_CURRENCY, metaPurchaseEventId, metaStartTrialEventId } from "@orsane/util/metaAds";

export function attachSignUpMetaEventId(
    dataLayer: Record<string, unknown>,
    userId?: string | null
): Record<string, unknown> {
    if (!userId) {
        return dataLayer;
    }
    return { ...dataLayer, meta_event_id: metaStartTrialEventId(userId) };
}

/**
 * The purchase push already carries `value` and `currency` for GA4. This only
 * fills those keys when a caller built an event without them, and always adds
 * `meta_event_id` on the `purchase` event (not the ecommerce-clear event).
 */
export function attachPurchaseMetaEventId(
    events: Record<string, unknown>[],
    subscriptionId: string
): Record<string, unknown>[] {
    const metaEventId = metaPurchaseEventId(subscriptionId);
    return events.map((event) => {
        if (event.event !== "purchase") {
            return event;
        }
        const currency =
            typeof event.currency === "string" && event.currency.trim().length > 0
                ? event.currency
                : DEFAULT_META_CURRENCY;
        const value = "value" in event ? {} : { value: undefined };
        return { ...event, ...value, currency, meta_event_id: metaEventId };
    });
}
